// Typescript hack to make it work with google enums
const landscapeManMade = 'landscape.man_made' as const;
const landscapeNatural = 'landscape.natural' as const;
const geometryFill = 'geometry.fill' as const;
const geometryStroke = 'geometry.stroke' as const;
const geometry = 'geometry' as const;

const labelsText = 'labels.text' as const;
const labelsTextFill = 'labels.text.fill' as const;
const labelIcon = 'labels.icon' as const;
const poi = 'poi' as const;
const poiAttraction = 'poi.attraction' as const;
const poiBusiness = 'poi.business' as const;
const poiGovernment = 'poi.government' as const;
const poiMedical = 'poi.medical' as const;
const poiPark = 'poi.park' as const;
const transitStationAirport = 'transit.station.airport' as const;
const water = 'water' as const;

const style = [
    {
        featureType: landscapeManMade,
        elementType: geometryFill,
        stylers: [
            {
                saturation: -65,
            },
            {
                lightness: 55,
            },
        ],
    },
    {
        featureType: landscapeManMade,
        elementType: geometryStroke,
        stylers: [
            {
                saturation: -70,
            },
            {
                lightness: 55,
            },
        ],
    },
    {
        featureType: landscapeNatural,
        elementType: geometry,
        stylers: [
            {
                saturation: -65,
            },
            {
                lightness: 40,
            },
        ],
    },
    {
        featureType: poiAttraction,
        elementType: geometry,
        stylers: [
            {
                saturation: -70,
            },
        ],
    },
    {
        featureType: poi,
        elementType: labelsText,
        stylers: [
            {
                saturation: -80,
            },
        ],
    },
    {
        featureType: poi,
        elementType: labelsTextFill,
        stylers: [
            {
                color: '#76848b',
            },
        ],
    },
    {
        featureType: poiAttraction,
        stylers: [
            {
                visibility: 'off',
            },
        ],
    },
    {
        featureType: poiAttraction,
        elementType: labelIcon,
        stylers: [
            {
                color: '#93a4ac',
            },
            {
                saturation: -75,
            },
            {
                visibility: 'on',
            },
        ],
    },
    {
        featureType: poiBusiness,
        stylers: [
            {
                visibility: 'off',
            },
        ],
    },
    {
        featureType: poiBusiness,
        elementType: labelIcon,
        stylers: [
            {
                color: '#93a4ac',
            },
            {
                saturation: -75,
            },
            {
                visibility: 'on',
            },
        ],
    },
    {
        featureType: poiGovernment,
        stylers: [
            {
                visibility: 'off',
            },
        ],
    },
    {
        featureType: poiGovernment,
        elementType: labelIcon,
        stylers: [
            {
                color: '#93a4ac',
            },
            {
                saturation: -75,
            },
            {
                visibility: 'on',
            },
        ],
    },
    {
        featureType: poiMedical,
        stylers: [
            {
                visibility: 'off',
            },
        ],
    },
    {
        featureType: poiMedical,
        elementType: labelIcon,
        stylers: [
            {
                color: '#e7c1c3',
            },
            {
                saturation: -5,
            },
            {
                visibility: 'on',
            },
        ],
    },
    {
        featureType: poiPark,
        elementType: geometry,
        stylers: [
            {
                color: '#a7e2ac',
            },
        ],
    },
    {
        featureType: poiPark,
        elementType: labelIcon,
        stylers: [
            {
                color: '#7ba67f',
            },
            {
                saturation: -95,
            },
            {
                visibility: 'on',
            },
        ],
    },
    {
        featureType: poiPark,
        elementType: labelsTextFill,
        stylers: [
            {
                color: '#7ba67f',
            },
        ],
    },
    {
        featureType: transitStationAirport,
        elementType: geometryStroke,
        stylers: [
            {
                visibility: 'off',
            },
        ],
    },
    {
        featureType: water,
        elementType: geometryFill,
        stylers: [
            {
                color: '#aadaff',
            },
        ],
    },
];

export default style;
